import { makeContractCancellationsRepository } from 'modules/customer/infra/repositories';

import { FetchOpenContractCancellationUseCase } from './implementations/FetchOpenContractCancellationUseCase';

let instance: FetchOpenContractCancellationUseCase | null = null;

export default function makeFetchOpenContractCancellationUseCase() {
  if (!instance) {
    const repository = makeContractCancellationsRepository();

    instance = new FetchOpenContractCancellationUseCase(repository);
  }

  return instance;
}
